import { render, staticRenderFns } from "./BlogSectionForm.vue?vue&type=template&id=610437ec"
import script from "./BlogSectionForm.vue?vue&type=script&lang=js"
export * from "./BlogSectionForm.vue?vue&type=script&lang=js"
import style0 from "./BlogSectionForm.vue?vue&type=style&index=0&id=610437ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports